import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';

import { getMe } from '../../services/users';

const AuthContext = createContext(null);

export const authStatus = {
  LOADING: 'loading',
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
};

export const AuthProvider = ({ children }) => {
  const [status, setStatus] = useState(authStatus.LOADING);
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      setStatus(authStatus.LOADING);
      const res = await getMe();
      setUser(res.data);
      setStatus(authStatus.AUTHENTICATED);
    } catch {
      setUser(null);
      setStatus(authStatus.UNAUTHENTICATED);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <AuthContext.Provider
      value={{ status, user, setStatus, checkAuth, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
